var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import FsLightbox from 'fslightbox-react';
import cs from 'classnames';
import { Portal } from 'ui-kit/portal';
import { LazyImage } from 'ui-kit/lazy-image';
import { FILE_END_POINT } from '../../constants/common';
import styles from './image-with-full-screen.module.scss';
export var ImageWithFullScreen = function (_a) {
    var imagePath = _a.imagePath, className = _a.className, rest = __rest(_a, ["imagePath", "className"]);
    var _b = useState(false), toggler = _b[0], setToggler = _b[1];
    var togglerRef = useRef(false);
    var data = useMemo(function () {
        var source = "".concat(FILE_END_POINT, "/").concat(imagePath);
        return { source: source, sourceArr: [source] };
    }, [imagePath]);
    useEffect(function () {
        togglerRef.current = toggler;
    }, [toggler]);
    var toggleHandler = useCallback(function () { return setToggler(!togglerRef.current); }, []);
    return (_jsxs(_Fragment, { children: [_jsx(LazyImage, __assign({ className: cs(styles.imageWithFullScreen, className), src: data.source }, rest, { onClick: toggleHandler })), _jsx(Portal, { children: _jsx(FsLightbox, { toggler: toggler, sources: data.sourceArr }) })] }));
};
